import { useState } from 'react';

interface Props {
  nome: string;
  quemMarcou: string;
  salvando: boolean;
  erro: string | null;
  aoVoltar: () => void;
  aoConfirmar: (motivo: string) => void;
}

function primeiroNome(nome: string): string {
  return (nome || '').trim().split(/\s+/)[0] || nome;
}

// Folha de confirmação para cancelar uma presença a partir da Frequência.
export default function FolhaCancelarPresencaFrequencia({
  nome,
  quemMarcou,
  salvando,
  erro,
  aoVoltar,
  aoConfirmar,
}: Props) {
  const [motivo, setMotivo] = useState('');
  const valido = motivo.trim().length >= 5;

  return (
    <div className="fixed inset-0 z-[60] flex items-end justify-center bg-black/30 sm:items-center sm:p-6">
      <div className="animate-modal-pop max-h-[90vh] w-full max-w-md overflow-y-auto rounded-t-lg bg-white p-6 sm:rounded-lg">
        <h3 className="text-lg font-medium text-foreground-950">
          Cancelar a presença de {primeiroNome(nome)}?
        </h3>
        <p className="mt-2 text-sm text-secondary-500">
          Use só quando tiver certeza de que a pessoa não estava. A presença passa a contar como
          falta, fica registrado quem cancelou e por quê, e dá para desfazer.
        </p>

        {quemMarcou && (
          <div className="mt-3 rounded-md border border-secondary-200 bg-background-50 px-3 py-2">
            <p className="text-xs text-foreground-600">{quemMarcou}</p>
          </div>
        )}

        <label className="mt-4 block text-xs font-medium text-foreground-700">
          Motivo (obrigatório)
        </label>
        <textarea
          value={motivo}
          onChange={(e) => setMotivo(e.target.value.slice(0, 500))}
          rows={3}
          maxLength={500}
          placeholder="Não estava na formação, conferido por …"
          className="mt-2 w-full resize-none rounded-md border border-secondary-300 bg-white px-3 py-2 text-sm text-foreground-950 outline-none placeholder:text-secondary-400 focus:border-primary-400"
        />
        <p className="mt-1 text-xs text-secondary-400">Mínimo de 5 letras.</p>

        {erro && (
          <p className="mt-3 rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
            {erro}
          </p>
        )}

        <div className="mt-5 flex gap-3">
          <button
            type="button"
            onClick={aoVoltar}
            disabled={salvando}
            className="flex-1 cursor-pointer whitespace-nowrap rounded-md border border-secondary-300 bg-white px-4 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100 disabled:opacity-60"
          >
            Voltar
          </button>
          <button
            type="button"
            onClick={() => aoConfirmar(motivo.trim())}
            disabled={!valido || salvando}
            className="flex-1 cursor-pointer whitespace-nowrap rounded-md bg-red-600 px-4 py-2.5 text-sm font-medium text-white transition-colors hover:bg-red-700 disabled:opacity-50"
          >
            {salvando ? 'Cancelando…' : 'Cancelar presença'}
          </button>
        </div>
      </div>
    </div>
  );
}